define([
	"dojo/_base/declare",
	"csi/core/ExtendedPath",
	"csi/reflection",
	"csi/xml",
	"csi/xml/Query",
	"csi/xml/QueryFilterBuilder"
], function(declare, ExtendedPath, reflection, xml, Query, QueryFilterBuilder) {

	return declare(null, {
		_MATERIAL: "Material",
		_STYLE: "Style",
		_PRODUCT: "Product",
		_PRODUCT_COLOR: "ProductColor",
		_PRODUCT_SIZE: "ProductSize",
		_REALIZED_PRODUCT: "RealizedProduct",

		__aggregateClassId: null,
		productClass: null,

		//Return Query
		_getQuery: function() {
			//Summary: Return query for action BusinessPlan new BPProductPlan from Product/Color/Size/SKU based on BusinessPlan filter attributes
			var nodeBusinessPlan = this.getParent();  //The BusinessPlan node

			var query = this._activeQuery();

			if (this.__aggregateClassId == this._PRODUCT_COLOR || this.__aggregateClassId == this._REALIZED_PRODUCT)
				query = this._productTypeHasColorQuery(query);
			if (this.__aggregateClassId == this._PRODUCT_SIZE || this.__aggregateClassId == this._REALIZED_PRODUCT)
				query = this._productTypeHasSizeQuery(query);

			query = this._productQueryFilter(nodeBusinessPlan, query);

			return query;
		},

		_extendedPrefixPath: function() {
			//summary: path prefix to be used in query
			if (this.__aggregateClassId == this._REALIZED_PRODUCT) {
				return ExtendedPath.create(this._REALIZED_PRODUCT, reflection.PATH_PARENT);
			}

			if (this.__aggregateClassId == this._PRODUCT_COLOR) {
				return ExtendedPath.create(this._PRODUCT_COLOR, reflection.PATH_PARENT);
			}

			return null;
		},

		_prefixPath: function() {
			//summary: path prefix to be used in query
			const ep = this._extendedPrefixPath();
			return ep ? ep.getStandardPath() : null;
		},

		_activeQuery: function() {
			//Summary: Query filter by Product.Active flag : Style SKU or ProductColor
			var query = new Query().Attr("Active", xml.OP_EQUALS, true, this._prefixPath());
			if ((this.productClass == this._STYLE && this.__aggregateClassId == this._REALIZED_PRODUCT)
				|| (this.__aggregateClassId == this._PRODUCT_COLOR))
				query.Attr("Active", xml.OP_EQUALS, true);
			return query;
		},

		_productTypeHasColorQuery: function(query) {
			query = query || new Query();
			var path = xml.path(this._prefixPath(), "Child:ProductType/Child:ProductionConfig");
			query.Attr("HasColor", xml.OP_EQUALS, true, path);

			return query;
		},

		_productTypeHasSizeQuery: function(query) {
			query = query || new Query();
			var path = xml.path(this._prefixPath(), "Child:ProductType/Child:ProductionConfig");
			query.Attr("HasSize", xml.OP_EQUALS, true, path);

			return query;
		},

		_productQueryFilter: function(nodeBusinessPlan, query) {
			var cache = this.getCache();

			if (xml.isValidURL(nodeBusinessPlan.QueryFilter)) {
				var qf = cache.addNode(nodeBusinessPlan.QueryFilter, function(req) {
					req.addDependencyPaths(["Child:Operands/Child:DataPointContainer"]);
				});

				QueryFilterBuilder.createWithPrefixPath(query, this._extendedPrefixPath(), qf.$URL, nodeBusinessPlan.$URL, cache);
			}

			return query;
		}
	});
});